import { STORE_NAME } from '@intigral/constant';
import { ROUTE_CONSTANT } from '../config/constants';
import h from '../helpers/common';
import url from '../helpers/url';
import { store } from '../store';
import { selectProfileDone } from '../store/reducers/profileSlice';

type NavigateFn = (to: string, options?: { replace?: boolean }) => void;

let navigateFn: NavigateFn | null = null;

export const setProfileSwitchNavigate = (navigate: NavigateFn) => {
    navigateFn = navigate;
};

export const redirectToSelectProfileOnSwitchError = () => {
    if (url.isCurrentRoute(ROUTE_CONSTANT.SELECT_PROFILE)) {
        return;
    }

    h.deleteStore(STORE_NAME.SELECTED_PROFILE);
    h.setContext({ [STORE_NAME.SELECTED_PROFILE]: {} });
    store.dispatch(selectProfileDone({}));

    const selectProfileRoute = url.route(ROUTE_CONSTANT.SELECT_PROFILE);
    if (navigateFn) {
        navigateFn(selectProfileRoute, { replace: true });
        return;
    }

    // Fallback if router navigate is not registered yet
    window.history.replaceState(null, '', selectProfileRoute);
};
